(function ($) {
  const initializeBlock = function ($block) {
    const $carousel = $block.find(".logoGrid.logoGrid--slider");
    if ($carousel.hasClass("slick-initialized")) {
      $carousel.slick("unslick");
    }

    if ($block.find(".logoGrid").first().hasClass("logoGrid--opposite")) {
      var rtlDirection = true;
    } else {
      var rtlDirection = false;
    }

    $carousel.slick({
      arrows: false,
      dots: false,
      swipe: true,
      centerMode: true,
      slidesToShow: 7,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 4000,
      rtl: rtlDirection,
      pauseOnHover: false,
      cssEase: "linear",
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            speed: 4000,
            slidesToShow: 5,
            slidesToScroll: 1,
            centerPadding: "0px",
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            centerPadding: "0px",
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 4000,
            centerPadding: "0px",
          },
        },
      ],
    });

    // Reinitialize the slider when the window is resized
    $(window).on("resize", function () {
      $block.find(".logoGrid.logoGrid--slider").slick("resize");
    });
  };

  $(document).ready(function () {
    $(".block--logo-grid").each(function () {
      initializeBlock($(this));
    });
  });

  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=logo-grid",
      initializeBlock
    );
  }
})(jQuery);
